import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import { EmailReportIcon } from '../../svgs/icons/EmailReportIcon';
import { XIcon } from '../../svgs/icons/XIcon';
import { styleSheet } from './styles';

interface CampaignReportBannerProps {
	className?: string;
	description: React.ReactNode;
	onClose?: () => void;
	styles?: StyleDeclarationValue[];
}

export const CampaignReportBanner: React.FC<CampaignReportBannerProps> = ({
	className,
	description,
	onClose,
	styles: customStyles,
}) => {
	return (
		<div className={`${css(styleSheet.container, ...(customStyles || []))} campaign-report-banner ${className || ''}`}>
			{onClose && (
				<Button variant='ghost' size='icon' onClick={onClose} styles={[styleSheet.closeButton]}>
					<XIcon />
				</Button>
			)}
			<div className={css(styleSheet.titleContainer)}>
				<figure className={css(styleSheet.circle)}>
					<EmailReportIcon />
				</figure>
				<div>
					<div className={css(styleSheet.title)}>Looking for all your campaigns?</div>
					<div className={css(styleSheet.titleMessage)}>{description}</div>
				</div>
			</div>
		</div>
	);
};
